module.exports = __webpack_public_path__ + "static/img/heartRate.8a9a2879.png";